import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { ThemeProvider } from '@mui/material/styles'

const mapStateToProps = (state) => ({ theme: state.theme.values })

const ThemeConnector = ({ children, theme }) => <ThemeProvider theme={theme}>{children}</ThemeProvider>

ThemeConnector.propTypes = {
  children: PropTypes.element.isRequired,
  theme: PropTypes.shape({}).isRequired,
}

export default connect(mapStateToProps)(ThemeConnector)
